import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { setCompanyDetails } from '../sidebar/sidebarreducer';
import { setLocalStorageItems } from '../scan/utils';

const Home = () => {
    const dispatch = useDispatch();
    const isLLAdminUser = useSelector(
        (state: RootState) => state.sideBarReducer.isLLAdminUser
    );

    const companyList = useSelector(
        (state: RootState) => state.sideBarReducer.companyList
    );

    const companyDetails: any = useSelector(
        (state: RootState) => state.sideBarReducer.companyDetails
    );

    const handleCompanyChange = useCallback((arg: any) => {
        try {
            const userCompanyMapping = companyList.find(
                (ele) => ele.companyId === parseInt(arg.target.value)
            );
            console.log(userCompanyMapping);
            setLocalStorageItems('companyId', arg.target.value);
            dispatch(setCompanyDetails(userCompanyMapping));
        } catch (error) {
            console.log(error);
        }
    }, []);

    return (
        <div className='mt-5'>
            <p>Environment: {process.env.NODE_ENV}</p>
            <p>Version:{process.env.REACT_APP_VERSION}</p>
            <p>URL:{process.env.REACT_APP_MASTER_URL}</p>
            <p>{process.env.REACT_APP_CLIENT_CONTEXT}</p>

            {!isLLAdminUser && (
                <div style={{ width: 250, margin: '0 auto' }}>
                <label className="label-title">Company Name </label>
                <select
                    disabled={companyList.length === 1}
                    onChange={(e: any) => handleCompanyChange(e)}
                    value={companyDetails?.companyId}
                    className="form-control"
                >
                    {companyList?.map((item: any, idx: number) => (
                        <option key={idx} value={item?.companyId}>
                            {item?.companyName}
                        </option>
                    ))}
                </select>
                {/* {userLocation === 0 ? <span className='text-danger'>{internalUserError.userLocationError}</span> : ''} */}
            </div>
            )}

           
        </div>
    );
};

export default Home;
